import { React } from '../../../lib'
import { reactFlyout } from '../../component-react'
import { Button } from '../buttons'
import { deleteNotes } from './delete'
import { quickTidyNotes } from './generative-tidy'
import { mergeDocuments } from './merge-notes'
import { EditNoteTagsMulti } from './tags'
import { NoteInfo, ReducerState } from './types'

export const NoteDetailsMultiSelect = <T extends Record<string, unknown>>(props: {
	rs: ReducerState<T>
	selected: NoteInfo<T>[]
}): React.JSX.Element => {
	const { rs, selected } = props
	return (
		<div className="relative h-full overflow-y-auto bg-neutral-300 text-center">
			<div className="p-3 font-condensed select-none text-center">
				{selected.length} notes selected
			</div>
			<div>
				<Button
					lbl="Edit Tags"
					type="borderless"
					img="/static/img/i8/color-edit.svg"
					onClick={() => {
						reactFlyout(
							'Edit Note Tags',
							[360, 360],
							<EditNoteTagsMulti rs={rs} selected={selected} />,
						)
					}}
				/>
			</div>
			<div>
				<Button
					lbl="Delete notes"
					type="borderless"
					img="/static/img/i8/color-trash-delete.svg"
					onClick={() => {
						deleteNotes(
							rs,
							selected.map(x => x.ID),
						)
					}}
				/>
			</div>
			<div>
				<Button
					lbl="Merge Documents"
					title="If the attachment types are supported, this will merge the attachments into a single document on a combined note. You can control the ordering on the confirmation screen"
					type="borderless"
					img="/static/img/i8/ios16-merge.svg"
					onClick={() => {
						mergeDocuments(rs, selected)
					}}
				/>
			</div>
			<div>
				<Button
					lbl="Auto Tidy"
					title="Analyse and tidy the note using a large language model"
					type="borderless"
					img="/static/img/i8/color-sparkles.svg"
					onClick={() => {
						quickTidyNotes(rs, selected)
					}}
				/>
			</div>
		</div>
	)
}
